import { useEffect } from "react";

type AlertType = "error" | "success" | "info" | "warning";

interface AlertProps {
    message: string;
    type?: AlertType;
    onClose?: () => void;
    autoHideMs?: number;
}

const iconMap: Record<AlertType, string> = {
    error: "rd-icon-cross",
    success: "rd-icon-done",
    info: "rd-icon-info",
    warning: "rd-icon-info",
};

export function Alert({
    message,
    type = "error",
    onClose,
    autoHideMs = 5000,
}: AlertProps) {
    useEffect(() => {
        if (!autoHideMs || !onClose) return;
        const timer = setTimeout(onClose, autoHideMs);
        return () => clearTimeout(timer);
    }, [autoHideMs, onClose]);

    return (
        <div className={`rd-alert rd-alert--${type}`}>
            <span className="rd-alert__icon">
                <span className={iconMap[type]}></span>
            </span>
            <span className="rd-alert__content">{message}</span>
            {onClose && (
                <button
                    type="button"
                    className="rd-alert__close"
                    onClick={onClose}
                >
                    <span className="rd-icon-cross"></span>
                </button>
            )}
        </div>
    );
}
